import {getLocalStorage} from '@/utils/main';

const useFloatingSize = () => {
  const size = getLocalStorage('floating_persona_size');
  const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 0;

  const sizeValueMap = {
    small: 150,
    medium: 200,
    large: 260,
  };

  const getEffectiveSize = () => {
    if (size === 'large' && windowWidth <= 1024) {
      return 'medium';
    }
    return size;
  };

  const effectiveSize = getEffectiveSize();

  const sizeValue = sizeValueMap[effectiveSize] || 200;

  return {
    size: effectiveSize,
    value: sizeValue,
  };
};

export default useFloatingSize;
